// EIGENE FUNKTIONEN
document.addEventListener('DOMContentLoaded', function () {
  // Funktion für Drag & Drop
  function clickAndDrag(selector, scroll_speed = 0.5, classOnEvent = 'grabbed_elem') {
    const slider = document.querySelector(selector);
    if (!slider) return; // Sicherheitsprüfung, falls das Element fehlt

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      e.preventDefault();
      isDown = true;
      slider.classList.add(classOnEvent);
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove(classOnEvent);
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove(classOnEvent);
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * scroll_speed; // Geschwindigkeit des Scrollens
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  // Funktion, um das aktive Element in den sichtbaren Bereich zu scrollen
  function scrollToActive(selector, activeClass) {
    const slider = document.querySelector(selector);
    if (!slider) return; // Sicherheitsprüfung, falls der Slider fehlt

    const activeItem = slider.querySelector(`.${activeClass}`);
    if (!activeItem) return; // Sicherheitsprüfung, falls kein aktives Element existiert

    // Berechnung der Scrollposition
    const containerRect = slider.getBoundingClientRect();
    const activeRect = activeItem.getBoundingClientRect();
    const containerScrollLeft = slider.scrollLeft;

    // Scrollposition anpassen, sodass das aktive Element sichtbar wird
    const offset = activeRect.left - containerRect.left;
    const scrollToPosition = containerScrollLeft + offset - containerRect.width / 2 + activeRect.width / 2;

    slider.scrollTo({
      left: scrollToPosition,
      behavior: 'smooth', // Sanftes Scrollen
    });
  }

  // Aufrufen der Funktionen
  clickAndDrag('.custom-menu', 0.5); // Drag-and-Drop aktivieren
  scrollToActive('.custom-menu', 'active'); // Aktives Element sichtbar machen
});
